import { useState } from 'react';
import cx from 'classnames';

import type { BackendOAuthConsentClient } from 'src/types/backend';

import styles from './ClientLogo.module.scss';

interface ClientLogoProps {
  className?: string;
  client: BackendOAuthConsentClient;
}

export const ClientLogo = ({ className, client }: ClientLogoProps) => {
  const [failed, setFailed] = useState(false);

  if (client.logoUri && !failed) {
    return (
      <img
        className={cx(styles.root, className)}
        src={client.logoUri}
        alt=""
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
        data-testid="oauthConsentClientLogo"
      />
    );
  }

  return (
    <span
      className={cx(styles.root, className, styles.initial)}
      aria-hidden
      data-testid="oauthConsentClientInitial"
    >
      {client.name.charAt(0).toUpperCase()}
    </span>
  );
};
